/*
    wiki: https://wiki.tmon.co.kr/x/X4DgEg
 */
import Console from './Console';
import ApiCall from './ApiCall';

const aPreset = ['TMON', 'TMON.oApp.htStorage.htStaticData.htDealInfo'];

export default class DebugConsole {
  constructor() {
    this.init();
  }

  update() {}

  init() {
    this.welContainer = $('#debugMode')
      .find('[data-role=tab-content][data-tab-id=console]')
      .find('[data-role=tab-content-inner]');
    // preset 을 넣어준다
    this.welContainer
      .find('#_debug_console_preset')
      .find('ul')
      .append(aPreset.map(item => `<li>${item}</li>`).join(''));
    // api 기본주소를 지정한다
    const welApiInput = this.welContainer
      .find('#_debug_api_controller')
      .children('input')
      .first();
    this.sDefaultUrl = welApiInput.data('defaultUrl');
    welApiInput.val(this.sDefaultUrl);

    this.oConsole = new Console();
    this.oApiCall = new ApiCall(this.sDefaultUrl);
  }

  clearEvent() {}
}
